
<div class="agpr-brandLogo">
    <div class="agpr-brandLogo-header">
        <span class="agpr-brandLogo-header-label">
            <label>{{ header | localize }}</label>
            @if (headerTooltip) {
                <span
                    role="img"
                    class="fa-regular fa-circle-info"
                    [agprTooltip]="headerTooltip"
                ></span>
            }
        </span>
        @if (showHeaderButton) {
            <ng-container *ngTemplateOutlet="uploadButton"></ng-container>
        }
    </div>
    @if (showSubHeader) {
        <div class="agpr-brandLogo-divider"></div>
        <ng-container *ngTemplateOutlet="subHeader"></ng-container>
    }
    <ng-container *ngTemplateOutlet="imageList"></ng-container>
</div>

<ng-template #subHeader>
    <div class="agpr-brandLogo-subHeader">
        <span class="agpr-brandLogo-subHeader-label">
            {{ 'Mention.workbench.subHeaderLabel' | localize : { maxFiles: this.maxFiles } }}
        </span>
        @if (showSubHeaderButton) {
            <ng-container *ngTemplateOutlet="uploadButton"></ng-container>
        }
    </div>
</ng-template>

<ng-template #uploadButton>
    <div class="agpr-brandLogo-uploadButton">
        @if (useSplitButton) {
            <agpr-split-button
                [id]="id + '_splitButton'"
                [style]="buttonTypes.icon"
                icon="fa-regular fa-duotone fa-square-plus"
                [tooltip]="'Common.brandInformation.logo.upload.tooltip'"
                [tooltipPosition]="'top'"
                [options]="uploadOptions"
                [panelPositionY]="'bottom'"
                [panelPositionX]="'right'"
                [disabled]="disabled"
            ></agpr-split-button>
        }@else {
            <agpr-button
                [id]="id + '_uploadButton'"
                [style]="!!uploadButtonLabel ? buttonTypes.tertiary : buttonTypes.icon"
                [label]="uploadButtonLabel | localize"
                [icon]="uploadButtonIcon"
                [tooltip]="'Common.brandInformation.logo.upload.tooltip'"
                [tooltipPosition]="'top'"
                (click)="fileUploadInput.click()"
                [ariaDescribedBy]="id + 'header_label'"
                [disabled]="disabled"
            ></agpr-button>
        }
        <input
            #fileUploadInput
            [id]="id + '_uploadInput'"
            style="display: none;"
            type="file"
            [accept]="acceptTypes"
            (change)="onFileSelected($event)"
            aria-hidden="true"
        />
    </div>
</ng-template>

<ng-template #imageList>
    @if (_value.length) {
        <ul
            class="agpr-brandLogo-list"
            agprListKeyboardNavigation
            [list]="_value"
        >
            @for (image of _value; track i; let i = $index;) {
                <li
                    class="agpr-brandLogo-listItem agpr-contextMenu-parent"
                    [class]="{
                        'agpr-brandLogo-listItem--withThumbnail': showThumbnail
                    }"
                >
                    <div class="agpr-brandLogo-card">
                        @if (showThumbnail) {
                            <div class="agpr-brandLogo-card-thumbnail-container">
                                @if (image && !imageErrors[i]) {
                                    <img
                                        class="agpr-brandLogo-card-thumbnail-img"
                                        [src]="image.source"
                                        [alt]="image.name"
                                        (error)="imageErrors[i] = true"
                                    />
                                } @else {
                                    <span
                                        role="img"
                                        class="agpr-brandLogo-card-thumbnail-icon fa-regular fa-duotone fa-file-image"
                                        aria-hidden="true"
                                    ></span>
                                }
                            </div>
                        }
                        <span class="agpr-brandLogo-card-content">
                            @if(image.name) {
                                <span
                                    [id]="id + '_image_' + i"
                                    class="agpr-brandLogo-card-name"
                                    [agprTooltip]="image.name"
                                    >
                                    {{ image.name }}
                                </span>
                            } @else {
                                <agpr-text-input
                                    [id]="id + '_image_' + i"
                                    class="agpr-brandLogo-card-sourceInput"
                                    [placeholder]="'Mention.editDialog.imageUrl.placeholder'"
                                    [(ngModel)]="image.source"
                                    [ngModelOptions]="{ updateOn: 'blur' }"
                                    (ngModelChange)="imageErrors[i] = false; emitValue()"
                                    [bottomMargin]="false"
                                    [disabled]="disabled"
                                ></agpr-text-input>
                            }
                        </span>
                    </div>
                    <div class="agpr-contextMenu top right">
                        <agpr-button
                            [id]="id + '_removeFileButton_' + i"
                            class="agpr-brandLogo-card-removeButton"
                            [style]="buttonTypes.contextMenu"
                            [icon]="showThumbnail ? 'fa-regular fa-duotone fa-square-xmark' : 'fa-regular fa-duotone fa-trash-can'"
                            [tooltip]="'Common.brandInformation.logo.removeImage'"
                            [tooltipPosition]="'top'"
                            [ariaDescribedBy]="id + '_image_' + i"
                            (click)="removeImage(i)"
                            [disabled]="disabled"
                        ></agpr-button>
                    </div>
                </li>
            }
        </ul>
    } @else {
        <agpr-message
            [id]="id + '_noImagesMessage'"
            class="agpr-brandLogo-noImagesMessage"
            [severity]="messageSeverity.noContent"
            [bottomMargin]="false"
        >
            {{ 'Common.brandInformation.logo.noImages' | localize}}
        </agpr-message>
    }
</ng-template>

